export default "/assets/images/CC-product.png?e9eb9216619025ab7a809b7253947ba6";